import { BAPI_COMMANDS } from "@/bapi-client/types/commands";
import { fetchHandler } from "@/bapi-client/fetch";
import type { Result } from "@/bapi-client/types";
import type { InviteUserRequest, RolesResponse, UsersAndRolesResponse } from "@/bapi-client/types/roles";

export async function getCustomerRoles(customerId: string): Promise<Result<RolesResponse>> {
  const response = await fetchHandler(BAPI_COMMANDS.ROLES_GET_CUSTOMER_ROLES, "GET", `/roles/${customerId}`);

  if (!response.success) return response;

  const parsed = await response.data.json();
  return parsed;
}

export async function getUsersAndRoles(customerId: string): Promise<Result<UsersAndRolesResponse>> {
  const response = await fetchHandler(BAPI_COMMANDS.ROLES_GET_USERS_AND_ROLES, "GET", `/roles/${customerId}/users`);

  if (!response.success) return response;

  const parsed = await response.data.json();
  return parsed;
}

export async function setUserRole(
  customerId: string,
  userId: string,
  roleId: string,
): Promise<Result<{ success: boolean }>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.ROLES_SET_USER_ROLE,
    "POST",
    `/roles/${customerId}/user/${userId}`,
    { body: { role_id: roleId } },
  );

  if (!response.success) return response;

  const parsed = await response.data.json();
  return parsed;
}

export async function inviteUser(
  customerId: string,
  requestBody: InviteUserRequest,
): Promise<Result<{ success: boolean }>> {
  const response = await fetchHandler(BAPI_COMMANDS.ROLES_INVITE_USER, "POST", `/roles/${customerId}/user/invite`, {
    body: requestBody,
  });

  if (!response.success) return response;

  const parsed = await response.data.json();
  return parsed;
}

export async function resendInvite(customerId: string, userId: string): Promise<Result<{ success: boolean }>> {
  const response = await fetchHandler(
    BAPI_COMMANDS.ROLES_RESEND_INVITE,
    "POST",
    `/roles/${customerId}/user/${userId}/invite`,
  );

  if (!response.success) return response;

  const parsed = await response.data.json();
  return parsed;
}

export async function deleteUser(customerId: string, userId: string): Promise<Result<{ success: boolean }>> {
  const response = await fetchHandler(BAPI_COMMANDS.ROLES_DELETE_USER, "DELETE", `/roles/${customerId}/user/${userId}`);

  if (!response.success) return response;

  const parsed = await response.data.json();
  return parsed;
}
